// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bbf20a31","545":"b0d86421"}[chunkId] + ".chunk.js";
};